import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../Controller/CreateContactDocumentController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
import { useDropzone } from 'react-dropzone';
import DocumentService from "../../../Setup/controller/DocumentController/DocumentController";
function CreateContactDocument({ modalInstance, currentContactDocument, onClose, onSuccess, ClientContactID }) {
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    const [formData, setFormData] = useState({
        ClientContactID: ClientContactID, FileName: '', Path: '', Name: '',
        Description: '', File: null, CompanyDocument: 0
    });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [DocuemntList, setDocumentList] = useState([]);
    useEffect(() => {
        fetchDocument();
        if (currentContactDocument) {
            setFormData({
                ClientContactID: ClientContactID, FileName: currentContactDocument.FileName, Path: currentContactDocument.Path,
                Name: currentContactDocument.Name, Description: currentContactDocument.Description, File: null,
                CompanyDocument: 0
            });
        } else {
            setFormData({
                ClientContactID: ClientContactID, FileName: '', Path: '', Name: '',
                Description: '', File: null, CompanyDocument: 0
            });
        }
    }, [currentContactDocument]);
    const fetchDocument = async (ModuleID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const list = await DocumentService.GetDocuments(redirectCallback, "15");
            setDocumentList(list);
        } catch (error) {
            console.error('Error fetching Project Members:', error);
        }
    };
    const handleFieldChange = (event) => {
        const { name, value } = event.target;

        if (name === "CompanyDocument") {
            const doc = DocuemntList.filter(
                x => x.ID.toString() === value.toString()
            );

            setFormData(prevState => ({
                ...prevState,
                [name]: value,
                Name: doc[0]?.DocumentName || "",
                Description: doc[0]?.Description || ""
            }));
        } else {
            setFormData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setFormData(prevState => ({
            ...prevState,
            File: file,
            Path: file ? file.name : ''
        }));
    };

    const handleFormSubmit = (event) => {

        event.preventDefault();

        if (currentContactDocument) {
            formData.DocID = currentContactDocument.DocID;
        } else {
            formData.DocID = 0;
        }
        formData.ClientContactID = ClientContactID;
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        formData.ClientContactID = ClientContactID;
        handleSubmit(event, formData, setFormData, setErrors, () => {
            onSuccess();

        }, () => {
            onSuccess();

        });
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const onDrop = (acceptedFiles) => {
        const file = acceptedFiles[0];
        if (file) {
            setFormData(prevState => ({
                ...prevState,
                File: file,
                Path: file.name
            }));
        }
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade contactDocumentModal show d-block" id="contactDocumentModal" tabIndex="-1" aria-labelledby="contactDocumentModalLabel" aria-hidden="true" data-backdrop="static">

                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-header" onStart={handleStart}
                            cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                            bounds={{ top: 0, bottom: window.innerHeight - 400 }}>
                            <div className="modal-content">
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title" id="largeModalLabel">{currentContactDocument ? "Edit Document" : "Add Document"}</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <table style={{ width: "100%" }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: "13%" }}>
                                                    <label htmlFor="Name" style={{ float: "right" }}>Company Docs  &nbsp;&nbsp;</label>
                                                </td>
                                                <td style={{ width: "37%" }}>
                                                    <select name="CompanyDocument" className='form-control' value={formData.CompanyDocument} onChange={handleFieldChange}>
                                                        <option value="0">New Document</option>
                                                        {DocuemntList.map((document) => (
                                                            <option key={document.ID} value={document.ID}>
                                                                {document.DocumentName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </td>
                                                <td style={{ width: "13%" }}></td>
                                                <td style={{ width: "37%" }}></td>

                                            </tr>
                                            <tr>
                                                <td style={{ marginLeft: "13%" }}><label htmlFor="Name" style={{ float: "right" }}>Name <span style={{ "color": "red" }}>*</span></label></td>
                                                <td style={{ marginLeft: "37%" }}>
                                                    <input type="text" className="form-control" name="Name" value={formData.Name} onChange={handleFieldChange} />
                                                    {errors.Name && <div style={{ color: 'red' }}>{errors.Name}</div>}
                                                </td>
                                                <td style={{ marginLeft: "13%" }}>
                                                    <label htmlFor="Description" style={{ float: "right" }}>Description &nbsp;&nbsp;</label>
                                                </td>
                                                <td style={{ marginLeft: "37%" }}>
                                                    <input type="text" className="form-control" name="Description" value={formData.Description} onChange={handleFieldChange} />
                                                    {errors.Description && <div style={{ color: 'red' }}>{errors.Description}</div>}
                                                </td>
                                            </tr>

                                            {(formData.CompanyDocument.toString() === "0" &&
                                                <tr>
                                                    <td>  <label htmlFor="Path" style={{ float: "right" }}>Attach File <span style={{ "color": "red" }}>*</span></label>
                                                    </td>
                                                    <td colSpan={3}>
                                                        <div
                                                            {...getRootProps()}
                                                            style={{
                                                                border: '2px dashed #ccc',
                                                                padding: '20px',
                                                                borderRadius: '6px',
                                                                textAlign: 'center',
                                                                backgroundColor: isDragActive ? '#e6f7ff' : '#ffffff',
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            <input {...getInputProps()} />
                                                            {
                                                                formData.Path
                                                                    ? <p>{formData.Path}</p>
                                                                    : <p>Drag & drop a file here, or click to select</p>
                                                            }
                                                        </div>
                                                        {errors.Path && <div style={{ color: 'red' }}>{errors.Path}</div>}

                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary">
                                        <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />
                                        {currentContactDocument ? " Update" : " Save"}

                                    </button>
                                    <button className="btn btn-danger" type="button" aria-label="Close" onClick={onClose}>
                                        <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                    </button>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>

            </form >
        </div >
    );
}

export default CreateContactDocument;
